module.exports = __webpack_public_path__ + "static/media/AGalaxyofWhalesBookJacket.e421b407.jpg";